import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import auth from '@/store/auth'
import { Common } from '@/utils/common'

Vue.use(VueRouter)

const settingRoutes: Array<RouteConfig> = [
  {
    path: '/user-send-email',
    name: 'SettingSendEmail',
    component: () => import('../views/SettingSendEmail.vue')
  },
  {
    path: '/user-pw',
    name: 'SettingPassword',
    component: () => import('../views/SettingPassword.vue')
  }
]

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    redirect: '/customer'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/customer',
    name: 'Customer',
    component: () => import('../views/Customer.vue')
  },
  {
    path: '/owner',
    name: 'Owner',
    component: () => import('../views/Owner.vue')
  },
  {
    path: '/building',
    name: 'Building',
    component: () => import('../views/Building.vue')
  },
  {
    path: '/board',
    name: 'Board',
    component: () => import('../views/Board.vue')
  },
  {
    path: '/event',
    name: 'Event',
    component: () => import('../views/Event.vue')
  },
  {
    path: '/chat/:category',
    name: 'Chat',
    component: () => import('../views/Chat.vue')
  },
  {
    path: '/useful',
    name: 'Useful',
    component: () => import('../views/Useful.vue')
  },
  {
    path: '/doc',
    name: 'Doc',
    component: () => import('../views/Doc.vue')
  },
  {
    path: '/relocation',
    name: 'Relocation',
    component: () => import('../views/Relocation.vue')
  },
  {
    path: '/csv-import',
    name: 'CsvImport',
    component: () => import('../views/CsvImport.vue')
  }
]

const router = new VueRouter({
  routes: Common.isUserSettingMode() === true ? settingRoutes : routes
})

router.beforeEach(async (to, from, next) => {
  if (Common.isUserSettingMode() === true) {
    next()
    return
  }
  if (to.name === 'Login' || to.name === 'ResetPassword' || auth.signed) {
    next()
  } else {
    const hasSession = await auth.hasSession()
    if (hasSession === true) {
      next()
    } else {
      next({ name: 'Login' })
    }
  }
})

router.afterEach(async () => {
  if (Common.isUserSettingMode() === true) {
    return
  }
  if (auth.signed && auth.account === null) {
    await auth.getAccountInfo()
  }
})

export default router
